import { render } from "./poll.vue?vue&type=template&id=0a849bbd&ts=true"
import script from "./poll.vue?vue&type=script&lang=ts"
export * from "./poll.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__